import { useQueryFolderAncestors } from "./useQueryFolderAncestors";

interface Input {
  folderId?: string;
}

export function useFolderAncestors({ folderId }: Input) {
  const { ancestors, isAncestorsLoading } = useQueryFolderAncestors({
    folderId,
  });

  return {
    ancestors,
    isAncestorsLoading,
  };
}
